import { render, staticRenderFns } from "./userDashBoard.vue?vue&type=template&id=9506a502&"
import script from "./userDashBoard.vue?vue&type=script&lang=js&"
export * from "./userDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./userDashBoard.vue?vue&type=style&index=0&id=9506a502&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomSheet,VCard,VCardSubtitle,VCardText,VCardTitle,VCol,VRow})
